<template>
  <div class="Event" v-if="data">
    <div class="Frame1">
      <img :src="data.broadcasterEvent.headerImageUrl" />
      <div class="Frame1-1">
        <p class="theme_white date">
          {{ fullDate(data.broadcasterEvent.endAt) }}
        </p>
        <p class="theme_accent80 rank">
          {{ displayText }}
        </p>
        <p class="theme_accent80 point">
          {{ data.broadcasterEventResult.score.toLocaleString() }}pt
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import type * as schema from '@/api/schema/appGatewayServer'
import dayjs from 'dayjs'
import { getRankOrdinalSuffix } from '@/i18n'

@Component
export default class EventInfo extends Vue {
  @Prop({ required: true })
  data!: schema.MemoryAlbumEvent

  fullDate(dateIso: string): string {
    return dayjs(dateIso).format('YYYY/MM/DD')
  }

  get displayText(): string {
    const rank = this.data.broadcasterEventResult.rank
    let numberOfWinners = 0
    switch (this.data.broadcasterEvent.eventType) {
      case 2: // スコア達成イベント
        return this.$t('memoriesScoreAchived').toString()
      case 3: // スコア達成ランキングイベント
        // ランキング型なのに入賞者数(number_of_winners)が設定されていない => 閾値(threshold)に入っている
        numberOfWinners = this.data.broadcasterEvent.numberOfWinners
        if (numberOfWinners === 0) {
          numberOfWinners = this.data.broadcasterEvent.threshold
        }
        if (rank <= numberOfWinners) {
          return rank + getRankOrdinalSuffix(rank).toString()
        } else {
          return this.$t('memoriesScoreAchived').toString()
        }
      case 1: // ランキングイベント
      default:
        return rank + getRankOrdinalSuffix(rank).toString()
    }
  }
}
</script>

<style scoped>
.theme_accent80 {
  color: #C0B6FF;
}

.theme_white {
  color: #FFFFFF
}

.Event {
  width: 327px;
  height: 58px;

  position: relative;
  font-family: -apple-system, BlinkMacSystemFont;
  margin-top: 8px;
}

.Frame1 {
  position: absolute;
  width: 326px;
  height: 58px;
  left: 0px;
  top: 0px;
  padding: 0px;
}

.Event img {
  position: absolute;
  width: 174px;
  height: 58px;
  left: 0px;
  top: 0px;
}

.Frame1-1 {
  position: absolute;
  width: 144px;
  height: 54px;
  padding: 0px;
  left: 182px;
  top: 0px;
}

.Event .date {
  position: absolute;
  top: 0px;
  height: 13px;

  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
}

.Event .rank {
  position: absolute;
  top: 15px;
  height: 24px;

  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
}

.Event .point {
  position: absolute;
  top: 41px;
  height: 13px;

  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
}
</style>
